import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  viewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { MatInputModule } from '@angular/material/input'
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { NgxMaskDirective } from 'ngx-mask'
import moment from 'moment'
import { emailValidator } from '../../../../shared/utils/email_validator'
import { ModalServiceAdditionalComponent } from '../../modal-service-additional/modal-service-additional.component'
import { MatDialog } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { convertCurrency } from '../../../../shared/utils/utils'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { IntegerInputDirective } from '../../../../shared/directives/IntegerInput'
import { JsonPipe } from '@angular/common'

@Component({
  selector: 'service-additional-proposal-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDatepicker,
    NgxMaskDirective,
    MatIcon,
    CurrencyInputDirective,
    IntegerInputDirective,
  ],
  templateUrl: './service-additional-proposal-form.component.html',
  styleUrl: './service-additional-proposal-form.component.scss',
  providers: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceAdditionalProposalFormComponent
  implements OnInit, OnChanges
{
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private dialog: MatDialog,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false
  serviceAdditionalSelected: any = {}

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  // @ViewChild('birth') datepicker: MatDatepicker<any> | undefined
  datepicker = viewChild<MatDatepicker<any>>('date')

  listType: any[] = []

  maxDate!: Date

  ngOnInit(): void {
    this.createForm()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.serviceAdditionalSelected = this.editItem.serviceAdditional
    this.form.get('amount')?.setValue(this.editItem.amount)
    this.form.get('priceUnit')?.setValue(this.editItem.priceUnit)
    this.form.get('date')?.setValue(this.editItem.date)
    this.form.get('priceTotal')?.setValue(this.editItem.priceTotal)
    this.form.get('tax')?.setValue(this.editItem.tax)

    this.form
      .get('serviceAdditional')
      ?.setValue(this.serviceAdditionalSelected.descricao)
    this.form
      .get('serviceAdditionalPrice')
      ?.setValue(convertCurrency(this.serviceAdditionalSelected.valor))

    // amount: this.form.controls['amount'].value,
    //   priceUnit: this.form.controls['priceUnit'].value,
    //   priceTotal: this.form.controls['priceTotal'].value,
    //   serviceAdditionalId: this.serviceAdditionalSelected.id,
    //   serviceAdditional: this.serviceAdditionalSelected,
  }

  resetForm() {
    // this.form.reset()
    this.createForm()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      serviceAdditional: ['', [Validators.required]],
      serviceAdditionalPrice: ['', [Validators.required]],
      amount: [1, [Validators.required]],
      priceUnit: ['', [Validators.required]],
      date: ['', [Validators.required]],
      priceTotal: ['', [Validators.required]],
      tax: ['5,00'],
    })
    this.form.get('priceTotal')?.disable()
    this.form.get('serviceAdditionalPrice')?.disable()
  }

  createAddress() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.resetForm()
    this.loading = false
  }

  editAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.serviceAdditionalSelected = {}
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }
  createModel(edit: boolean = false) {
    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        amount: this.form.controls['amount'].value,
        priceUnit: this.form.controls['priceUnit'].value,
        priceTotal: this.form.controls['priceTotal'].value,
        date: this.form.controls['date'].value,
        serviceAdditionalId: this.serviceAdditionalSelected.id,
        serviceAdditional: this.serviceAdditionalSelected,

        descricao: this.serviceAdditionalSelected.descricao,
        priceUnit_formatted: 'R$ ' + this.form.controls['priceUnit'].value,
        date_formatted: moment(this.form.get('date')!.value).format(
          'DD/MM/YYYY',
        ),
        priceTotal_formatted: 'R$ ' + this.form.controls['priceTotal'].value,
        tax:
          this.form.controls['tax'].value != ''
            ? parseFloat(
                this.form.controls['tax'].value
                  .replaceAll('.', '')
                  .replaceAll(',', '.'),
              )
            : 0,
        tax_formatted: this.form.controls['tax'].value + ' %',
      }
    } else {
      return {
        amount: this.form.controls['amount'].value,
        priceUnit: this.form.controls['priceUnit'].value,
        priceTotal: this.form.controls['priceTotal'].value,
        date: this.form.controls['date'].value,
        serviceAdditionalId: this.serviceAdditionalSelected.id,
        serviceAdditional: this.serviceAdditionalSelected,

        descricao: this.serviceAdditionalSelected.descricao,
        priceUnit_formatted: 'R$ ' + this.form.controls['priceUnit'].value,
        date_formatted: moment(this.form.get('date')!.value).format(
          'DD/MM/YYYY',
        ),
        priceTotal_formatted: 'R$ ' + this.form.controls['priceTotal'].value,
        tax:
          this.form.controls['tax'].value != ''
            ? parseFloat(
                this.form.controls['tax'].value
                  .replaceAll('.', '')
                  .replaceAll(',', '.'),
              )
            : 0,
        tax_formatted: this.form.controls['tax'].value + ' %',
      }
    }
  }

  openDatepicker() {
    this.datepicker()?.open()
  }

  calculateTotal() {
    let priceUnit =
      typeof this.form.controls['priceUnit'].value == 'string'
        ? convertCurrency(this.form.controls['priceUnit'].value)
        : this.form.controls['priceUnit'].value
    let amount =
      typeof this.form.controls['amount'].value == 'string'
        ? convertCurrency(this.form.controls['amount'].value)
        : this.form.controls['amount'].value

    let tax =
      typeof this.form.controls['tax'].value == 'string'
        ? convertCurrency(this.form.controls['tax'].value)
        : this.form.controls['tax'].value

    let total = priceUnit * amount * (1 + tax / 100)

    total = Math.ceil(!isFinite(total) ? 0 : (total ?? 0))

    if (total) {
      this.form.get('priceTotal')?.setValue(convertCurrency(total))
    } else {
      this.form.get('priceTotal')?.setValue(convertCurrency(0))
    }
  }

  addAdditionalService() {
    const dialogRef = this.dialog.open(ModalServiceAdditionalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        multiSelect: false,
        item: this.serviceAdditionalSelected,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.serviceAdditionalSelected.id) {
            this.serviceAdditionalSelected = response.selection
            console.log('desc: ', response)
            this.form
              .get('serviceAdditional')
              ?.setValue(this.serviceAdditionalSelected.descricao)
            this.form
              .get('serviceAdditionalPrice')
              ?.setValue(convertCurrency(this.serviceAdditionalSelected.valor))
            this.form
              .get('priceUnit')
              ?.setValue(convertCurrency(this.serviceAdditionalSelected.valor))
            this.form.get('amount')?.setValue(1)
            this.calculateTotal()
          }
        } else {
          this.serviceAdditionalSelected = {}
          this.form.get('serviceAdditional')?.setValue('')
          this.form.get('serviceAdditionalPrice')?.setValue('')
          this.form.get('amount')?.setValue(1)
          this.form.get('priceUnit')?.setValue('')
          this.form.get('priceTotal')?.setValue('')
        }
      }
    })
  }
}
